import React, { useContext } from 'react';
import styled from 'styled-components';
import { ToggleGroup } from './index';
import { safeGet } from '../../../../../../core/util/object';
import { fontSize } from '../../../../../../constants/text';
import { analyticsTrackEvent } from '../../../../../../core/analytics';
import {
  CDP_BOOK_MODULE_ACTION,
  CDP_BOOK_MODULE_EVENT,
} from '../../../../../../core/analytics/events';
import { getDevice } from '../../../../../../core/util/device';
import { LocationContext } from '../../../../ContextProviders';

const Root = styled.div.withConfig({ componentId: 'sc-1wiveh9-0' })<{ $isPickATimeSelected?: boolean }>`
  ${(props) => (props.$isPickATimeSelected ? '' : 'margin-bottom: 20px;')}
`;

const TelemedSla = styled.div.withConfig({ componentId: 'sc-1wiveh9-1' })`
  font-size: ${fontSize.small};
  text-align: center;
`;

type Props = {
  handleNextAvailableClick: (...args: any[]) => any;
  handlePickATimeClick: (...args: any[]) => any;
  isPickATimeSelected?: boolean;
  visible?: boolean;
};

const NextAvailablePickATimeToggle = (props: Props) => {
  const { handleNextAvailableClick, handlePickATimeClick, isPickATimeSelected, visible } = props;
  const { location } = useContext(LocationContext);

  const getNextAvailableToggleContent = () => (
    <>
      <div>Next Available</div>
      {safeGet(location)('telemedSla') && (
        <TelemedSla>{`Within ${location.telemedSla} min`}</TelemedSla>
      )}
    </>
  );

  const toggleOptions = [
    {
      copy: getNextAvailableToggleContent(),
      onClick: () => {
        handleNextAvailableClick();
        analyticsTrackEvent(CDP_BOOK_MODULE_EVENT, {
          action: CDP_BOOK_MODULE_ACTION.CLICK_NEXT_AVAILABLE,
          device: getDevice(),
          locationId: location.id,
          uclId: location.uclId,
        });
      },
      isSelected: !isPickATimeSelected,
    },
    {
      copy: 'Pick a Time',
      onClick: () => {
        handlePickATimeClick();
        analyticsTrackEvent(CDP_BOOK_MODULE_EVENT, {
          action: CDP_BOOK_MODULE_ACTION.CLICK_PICK_A_TIME,
          device: getDevice(),
          locationId: location.id,
          uclId: location.uclId,
        });
      },
      isSelected: isPickATimeSelected,
    },
  ];

  if (!visible) return null;

  return (
    <Root $isPickATimeSelected={isPickATimeSelected}>
      <ToggleGroup toggleOptions={toggleOptions} />
    </Root>
  );
};

export default NextAvailablePickATimeToggle;
